import { RowContainer } from '@shared/ui';

import { Badge, Icon, Item } from './product-item.styles';

interface ProductItemProps {
  image: string;
  title: string;
  badgeText: string;
}

export const ProductItem = ({ image, title, badgeText }: ProductItemProps) => {
  return (
    <Item>
      <RowContainer $justify='space-between'>
        {title}
        <Badge>{badgeText}</Badge>
      </RowContainer>
      <Icon src={image} />
    </Item>
  );
};
